import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { UnsubscribeOnDestroyAdapter } from '../../../_shared';
import { AuthService } from '../../../_infrastructure/services/auth/user-auth/auth.service';
import { PerfisMaster } from '../../../_infrastructure/constants/perfil-master-utils';

@Component({
  selector: 'app-main-sidebar',
  standalone: false,
  templateUrl: './main-sidebar.component.html',
  styleUrl: './main-sidebar.component.css'
})
export class MainSidebarComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  isCollapsed = false;
  isMobile = false;
  perfilNome: string | null = null;
  exibirMenuMaster: boolean = false;

  constructor(private renderer: Renderer2,
    private readonly authService: AuthService) { super(); }

  ngOnInit() {
    this.subs.sink = this.authService.currentUser.subscribe(user => {
      this.perfilNome = user?.perfilNome || null;
      if (PerfisMaster.isMaster(this.perfilNome)) {
        this.exibirMenuMaster = true;
      }
      this.updateLayout();
    });
  }

  @HostListener('window:resize')
  updateLayout() {
    this.isMobile = window.innerWidth <= 1115;

    if (this.isMobile) {
      this.isCollapsed = true;
    }
  }

  toggleSidebar() {
    if (this.isMobile) {
      return;
    }

    this.isCollapsed = !this.isCollapsed;

    if (this.isCollapsed) {
      this.renderer.addClass(document.body, 'sidebar-collapsed');
    } else {
      this.renderer.removeClass(document.body, 'sidebar-collapsed');
    }
  }
} 